import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {
  sidetoggle: boolean = false;
 

  toggleSidebar() {
    this.sidetoggle = !this.sidetoggle;
  }
}
